/** How many ms to wait before debounced action is called */
export const DEBOUNCE_TIMEOUT = 600